import { render, staticRenderFns } from "./DoCompanyForm.vue?vue&type=template&id=96f63318"
import script from "./DoCompanyForm.vue?vue&type=script&lang=js"
export * from "./DoCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports